export enum QUERY_KEYS {
  activateEventPass = 'activate-event-pass',
  activateEventPassHolder = 'event-activate-pass-holder',
  activatePassHolder = 'activate-pass-holder',
  cancelEventPassHolder = 'event-cancel-pass-holder',
  cancelPassHolder = 'cancel-pass-holder',
  createPass = 'create-pass',
  deactivateEventPass = 'deactivate-event-pass',
  deleteCompanyPass = 'delete-company-pass',
  editCompanyPass = 'edit-company-pass',
  editEventPass = 'edit-event-pass',
  exportPassQrCodes = 'export-pass-qr-codes',
  getCompanyPasses = 'get-company-passes',
  getCompanyPassStats = 'get-company-pass-stats',
  getEventPassStats = 'get-event-pass-stats',
  getEventPasses = 'get-event-passes',
  getPassEvents = 'get-pass-events',
  getEventPassHolderList = 'event-pass-holder-list',
  getEventTicketHolderList = 'event-ticket-holder-list',
  getPassBooking = 'get-pass-booking',
  getPassChannelsById = 'pass-channels-by-id',
  getPassHolderList = 'pass-holder-list',
  getTicketHolderList = 'ticket-holder-list',
  updateSeasonPassItalyRegulation = 'update-season-pass-italy-regulation',
}
